module.exports = __webpack_public_path__ + "img/video.0575e4c3.png";